import { trajectorySectionCodeLookup } from '../../../config/api/models/Trajectory';
import { Icons } from '../../shared/components';
import { BlockType } from '../../../config/api/models/Block';
import { ExerciseLevel } from '../../../config/api/models/Exercise';
import { Theme } from '@material-ui/core';
import { GroupStudentSeriesScores, SeriesScores } from '../../../config/api/models/Score';
import { addSeconds, format } from 'date-fns';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

export const isValidSectionCode = (input: string): boolean =>
  Object.keys(trajectorySectionCodeLookup).includes(input);

export const getIconByType = (type: BlockType) => {
  switch (type) {
    case BlockType.WYSIWYG:
      return Icons.BLOCK_TYPE_WYSIWYG;
    case BlockType.IFRAME:
      return Icons.BLOCK_TYPE_IFRAME;
    case BlockType.H5P:
      return Icons.BLOCK_TYPE_EXERCISE;
    case BlockType.BOOK_WIDGET:
      return Icons.BLOCK_TYPE_EXERCISE;
    case BlockType.VIDEO:
      return Icons.BLOCK_TYPE_VIDEO;
    case BlockType.COLUMN:
      return Icons.COLUMN;
    case BlockType.ALGEBRA_KIT:
      return Icons.BLOCK_TYPE_EXERCISE;
    case BlockType.TEXT_EXERCISE:
      return Icons.BLOCK_TYPE_EXERCISE;
    default:
      return Icons.BOOK;
  }
};

export const getFAIconByType = (type: BlockType) => {
  switch (type) {
    case BlockType.WYSIWYG:
      return SpriteIconsLight.TYPEWRITER;
    case BlockType.IFRAME:
      return SpriteIconsLight.CODE_SIMPLE;
    case BlockType.H5P:
      return SpriteIconsLight.GAMEPAD_MODERN;
    case BlockType.BOOK_WIDGET:
      return SpriteIconsLight.GAMEPAD_MODERN;
    case BlockType.VIDEO:
      return SpriteIconsLight.CIRCLE_PLAY;
    case BlockType.COLUMN:
      return SpriteIconsLight.COLUMN;
    case BlockType.ALGEBRA_KIT:
      return SpriteIconsLight.GAMEPAD_MODERN;
    case BlockType.SECTION:
      return SpriteIconsLight.ARROWS_FROM_LINE;
    case BlockType.TEXT_EXERCISE:
      return SpriteIconsLight.GAMEPAD_MODERN;
    case BlockType.CLUSTER:
      return SpriteIconsLight.T_LETTER;
    default:
      return SpriteIconsLight.BOOK;
  }
};

export const getColorByLevel = (level: ExerciseLevel, theme: Theme) => {
  switch (level) {
    case '1':
      return theme.config.progressColors.bronze.main;
    case '2':
      return theme.config.progressColors.silver.main;
    case '3':
      return theme.config.progressColors.gold.main;
  }
};

export const getDifficultyByLevel = (level: ExerciseLevel) => {
  switch (level) {
    case '1':
      return 'one';
    case '2':
      return 'two';
    case '3':
      return 'three';
  }
};

export const formatSeconds = (seconds: number): string => {
  return format(addSeconds(new Date('1900-01-01 00:00:00'), seconds), 'm:ss');
};

export const getAverageExerciseScoreForGroup = (
  groupScores: GroupStudentSeriesScores,
  seriesId: string,
  exerciseId: string
): string => {
  const studentKeys: string[] = Object.keys(groupScores.students);

  let totalScore: number = 0;
  let totalMaxScore: number = 0;
  for (let i = 0; i < studentKeys.length; i++) {
    const studentSeriesScores: SeriesScores | undefined =
      groupScores.students[studentKeys[i]].scores[seriesId];
    if (!!studentSeriesScores && !!studentSeriesScores[exerciseId]) {
      totalScore += studentSeriesScores[exerciseId].score;
      totalMaxScore += studentSeriesScores[exerciseId].maxScore;
    }
  }
  if (totalMaxScore === 0) return '';

  return `${Math.round((totalScore / totalMaxScore) * 100)}%`;
};

export const resetScrollPosition = () => {
  const scrollContainer = document.getElementById('private_page_scroll_container');
  if (scrollContainer != null) scrollContainer.scrollTo(0, 0);
};

export const preProcessLatex = (input?: string): string => {
  let output: string = '';
  if (input != null) {
    output = input;

    const paragraphRegex = new RegExp(/<p>.*?<\/p>/gms);

    const matches: any = input.matchAll(paragraphRegex);
    if (matches) {
      for (const match of matches) {
        const paragraph = match.toString();

        if (paragraph.indexOf('mathrm') >= 0) {
          let formula = paragraph
            .toString()
            .replace('<p>', '')
            .replace('</p>', '')
            .replaceAll('\\\\', '\\')
            .replaceAll('$$', '')
            .replaceAll('*', '')
            .replaceAll('/-', '-')
            .replaceAll('\\(', '')
            .replaceAll('\\)', '');

          formula = `\\(${formula}\\)`;
          output = output.replace(paragraph, `<p>${formula}</p>`);
        }
      }
    }

    if (['<br>', '<p>', '<p><br>', '</p>'].includes(output)) output = '';
  }
  return output;
};
